<template>
  <section class="container">
    <LoginBox @logged="loggedIn" />
  </section>
</template>
<script>
import LoginBox from '~/components/user/LoginBox.vue'
export default {
  components: {
    LoginBox
  },
  head: {
    bodyAttrs: {
      id: 'login-page'
    }
  },
  data() {
    return {
      redirectUrl: '/myjob'
    }
  },
  middleware ({ app, store, redirect, params, route }) {
    const { slug } = route.params
    let uri = '/myjob'
    if (slug) {
      uri = slug
    }
    if (app.$auth.user) {
      return redirect(uri)
    }
  },
  watch: {

  },
  mounted() {
    if (this.$route.query.redirect) {
      this.redirectUrl = this.$route.query.redirect
    }
  },
  methods: {
    loggedIn: function() {
      this.$router.push({
        path: this.redirectUrl
      })
    }
  }
}

</script>
